export default "__VITE_ASSET__275c406f__"